/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-bootstrap/modal/modal-container.component';
import * as i2 from 'ngx-bootstrap/modal/modal-options.class';
import * as i3 from 'ngx-bootstrap/modal/bs-modal.service';
const styles_ModalContainerComponent:any[] = ([] as any[]);
export const RenderType_ModalContainerComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ModalContainerComponent,data:{}});
export function View_ModalContainerComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),4,'div',[['role','document']],[[8,'className',0]],(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class','modal-content']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵncd((null as any),0),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
          i0.ɵted((null as any),['\n  ']))],(null as any),(_ck,_v) => {
    var _co:i1.ModalContainerComponent = _v.component;
    const currVal_0:any = ('modal-dialog' + (_co.config.class? (' ' + _co.config.class): ''));
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ModalContainerComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'modal-container',
      [['class','modal'],['role','dialog'],['tabindex','-1']],(null as any),[[(null as any),
          'click'],['window','keydown.esc']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onClick($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('window:keydown.esc' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onEsc()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },View_ModalContainerComponent_0,RenderType_ModalContainerComponent)),i0.ɵdid(245760,
      (null as any),0,i1.ModalContainerComponent,[i2.ModalOptions,i0.ElementRef,i3.BsModalService,
          i0.Renderer],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ModalContainerComponentNgFactory:i0.ComponentFactory<i1.ModalContainerComponent> = i0.ɵccf('modal-container',
    i1.ModalContainerComponent,View_ModalContainerComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1jb250YWluZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1jb250YWluZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLk1vZGFsQ29udGFpbmVyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLk1vZGFsQ29udGFpbmVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdiBbY2xhc3NdPVwiJ21vZGFsLWRpYWxvZycgKyAoY29uZmlnLmNsYXNzID8gJyAnICsgY29uZmlnLmNsYXNzIDogJycpXCIgcm9sZT1cImRvY3VtZW50XCI+XG4gICAgICA8ZGl2IGNsYXNzPVwibW9kYWwtY29udGVudFwiPjxuZy1jb250ZW50PjwvbmctY29udGVudD48L2Rpdj5cbiAgICA8L2Rpdj5cbiAgIiwiPG1vZGFsLWNvbnRhaW5lcj48L21vZGFsLWNvbnRhaW5lcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLDJDQUNJO01BQUE7TUFBQSw0Q0FBeUY7TUFDdkY7VUFBQTthQUEyQixrQkFBK0IsMkNBQ3REO2lCQUFBOztJQUZEO0lBQUwsV0FBSyxTQUFMOzs7O29CQ0RKO01BQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsNkVBQUE7TUFBQTtxQkFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/ngx-bootstrap/modal/modal-container.component.ngfactory.ts